import { render, staticRenderFns } from "./office_box.vue?vue&type=template&id=b112ddc0&scoped=true"
import script from "./office_box.vue?vue&type=script&lang=js"
export * from "./office_box.vue?vue&type=script&lang=js"
import style0 from "./office_box.vue?vue&type=style&index=0&id=b112ddc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b112ddc0",
  null
  
)

export default component.exports